import { render, staticRenderFns } from "./PlayingMatch.vue?vue&type=template&id=c85aa848&scoped=true"
import script from "./PlayingMatch.vue?vue&type=script&lang=js"
export * from "./PlayingMatch.vue?vue&type=script&lang=js"
import style0 from "./PlayingMatch.vue?vue&type=style&index=0&id=c85aa848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85aa848",
  null
  
)

export default component.exports